import './index.scss'

function FieldValidation({ valid }: { valid: boolean }) {
    return (
        <div className='fieldValidation'>
            {!valid && <p>Ogiltigt värde</p>}
            {valid && <p/>}
        </div>
    )
}

export default FieldValidation;
